export function toggleRecordArrayValue<K>(
  originalValue: K[] | undefined,
  newValue: K
): K[] | undefined {
  if (!newValue) {
    return originalValue;
  }

  const result = originalValue?.filter((id) => id !== newValue);
  if ((result?.length ?? 0) < (originalValue?.length ?? 0)) {
    return result;
  }

  return [...(originalValue ?? []), newValue];
}
